export const initialState = {
    relatedNews: [],
    isFetching: false,
    isError: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_RELATED_NEWS': {
            return {
                relatedNews: [],
                isFetching: true,
                isError: false
            };
        }
        case 'RECEIVE_RELATED_NEWS': {
            return {
                relatedNews: action.data?.data || [],
                isFetching: false,
                isError: false
            };
        }
        case 'ERROR_RELATED_NEWS': {
            return {
                relatedNews: [],
                isFetching: false,
                isError: true
            };
        }
        default:
            return state;
    }
};
